var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { ModelCommunityUser } from '~/models/model.community.user';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { EContactsFilter } from '~/shared/types';
export let ServiceCommunityUser = class ServiceCommunityUser extends BaseSingletonService {
    users = observable.array([]);
    originalUsers = observable.array([]);
    selectedUser;
    constructor() {
        super();
        makeObservable(this);
    }
    setSelectedUser(selectedUser) {
        this.selectedUser = selectedUser;
    }
    filterUsersByMemberType(filterType) {
        if (!this.originalUsers?.length) {
            return;
        }
        if (filterType === EContactsFilter.all) {
            this.users.replace(this.originalUsers);
        }
        else {
            this.users.replace(this.originalUsers.filter(user => user.communityRole === filterType));
        }
    }
    getUsers(communityId) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${communityId}/${EApiUrl.users}`)
                .then(response => {
                runInAction(() => {
                    const users = Array.isArray(response.data)
                        ? plainToInstance(ModelCommunityUser, response.data)
                        : [];
                    this.users.replace(users);
                    this.originalUsers.replace(users);
                });
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", typeof (_a = typeof ModelCommunityUser !== "undefined" && ModelCommunityUser) === "function" ? _a : Object)
], ServiceCommunityUser.prototype, "selectedUser", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof EContactsFilter !== "undefined" && EContactsFilter) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], ServiceCommunityUser.prototype, "filterUsersByMemberType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ServiceCommunityUser.prototype, "getUsers", null);
ServiceCommunityUser = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [])
], ServiceCommunityUser);
